import {Component} from '@angular/core';
import {MachineEfficiencyLevel} from '@domain/machine/machine-efficiency-level.enum';
import {MachineStatus} from '@domain/machine/machine-status.enum';
import {MachineType} from '@domain/machine/machine-type.enum';
import {ReportDataSetTemplate} from '@domain/report-data-set/report-data-set-template';
import {ReportMachineDataSetTemplate} from '@domain/report-data-set/report-machine-data-set-template';
import {OverviewMachine} from '@presentation/pages/machine-overview/overview-machine';
import {ReportDataSetTemplateService} from '@presentation/pages/machine-overview/report-data-set-template/report-data-set-template.service';
import {ReportItem} from '@presentation/pages/machine-overview/report-item';
import {AssertionUtils, BaseComponent} from '@vdw/angular-component-library';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {map, takeUntil} from 'rxjs';
import {OverviewMachineEfficiencyCellRendererParams} from './overview-machine-efficiency-cell-renderer-params.interface';

@Component({
  selector: 'app-overview-machine-efficiency.component',
  templateUrl: './overview-machine-efficiency.component.html',
  styleUrls: ['./overview-machine-efficiency.component.scss']
})
export class OverviewMachineEfficiencyComponent extends BaseComponent implements ICellRendererAngularComp {
  public reportItemHeader: ReportItem;
  public canSeeReportItemHeader: boolean;
  public useReportItemData = false;

  private machine: OverviewMachine;

  public constructor(private readonly reportDataSetTemplateService: ReportDataSetTemplateService) {
    super();
  }

  public agInit(params: OverviewMachineEfficiencyCellRendererParams): void {
    this.useReportItemData = params.useReportItemData;
    this.machine = params.machine;

    if (this.useReportItemData) {
      this.getReportItemMachineEfficiency();
    }
  }

  public refresh(params: any): boolean {
    return false;
  }

  public hasEfficiency(): boolean {
    return !AssertionUtils.isNullOrUndefined(this.machine) && !AssertionUtils.isNullOrUndefined(this.machine.efficiency);
  }

  public getEfficiencyValue(): string {
    return String(this.machine.efficiency.value);
  }

  public isHigh(): boolean {
    return this.machine.efficiency?.level === MachineEfficiencyLevel.HIGH;
  }

  public isLow(): boolean {
    return this.machine.efficiency?.level === MachineEfficiencyLevel.LOW;
  }

  private canShowReportItemHeader(): boolean {
    return this.canShowReportItemHeader && !AssertionUtils.isNullOrUndefined(this.machine.status) && this.machine.status !== MachineStatus.DISCONNECTED && !this.machine.remoteMachine;
  }

  private getReportItemMachineEfficiency(): any {
    return this.reportDataSetTemplateService
      .getCurrentReportDataSetTemplate()
      .pipe(
        map((response: ReportDataSetTemplate) => {
          return (
            response.variants?.find((reportMachineDataSetTemplate: ReportMachineDataSetTemplate) => reportMachineDataSetTemplate.machineType === this.machine.machineType) ??
            response.variants?.find((reportMachineDataSetTemplate: ReportMachineDataSetTemplate) => reportMachineDataSetTemplate.machineType === MachineType.UNDEFINED)
          );
        }),
        takeUntil(this.unSubscribeOnViewDestroy)
      )
      .subscribe({
        next: (reportMachineDataSetTemplate: ReportMachineDataSetTemplate) => {
          if (!!reportMachineDataSetTemplate) {
            this.canSeeReportItemHeader = this.canShowReportItemHeader();
            const reportItemHeaderTemplate = reportMachineDataSetTemplate.getHeaderReportItem();

            this.reportItemHeader =
              this.machine.reportItems.find((reportItem: ReportItem) => reportItem.field === reportItemHeaderTemplate?.field) ?? new ReportItem(reportItemHeaderTemplate?.field, '');
          }
        }
      });
  }
}
